import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import axios from "../common/axios";
import {UserContext} from "../common/UserContext";
import Switch from "../common/Switch";
import ListItemCore from "../common/ListItemCore";
import {BrandContext} from "../common/BrandContext";

const NavTopicItem = props => {
    const {user, setUser} = useContext(UserContext);
    const brandConfig = useContext(BrandContext);
    const {className, classId, meta, url, topic, enabled = true, disabled = false, active = false, isExpanded = false, handleChangeTopic, handleUpdateConcepts, visible, ...other} = props;

    const handleChangeEnabled = event => {
        const locEnabled = event.target.checked;
        axios.get('/web/ui/content/enableConceptClassesByTopic',  {params: {topicId: topic.topicId, classId: classId, enabled: locEnabled}})
            .then(response => {
                handleUpdateConcepts(response.data);
                handleChangeTopic(topic);
            });
    };

    const handleClickTopic = event => {
        if (disabled) {
            return;
        }

        handleChangeTopic(topic);
    };

    const accessibleName = topic.topicName.replace(/<[^>]*>?/gm, '');

    return (
        <button
            id={`topic-${topic.topicId}`}
            role="tab"
            onClick={handleClickTopic}
            aria-label={accessibleName}
            aria-selected={active}
            aria-controls="concepts-panel"
            disabled={disabled}
            tabIndex={disabled ? -1 : (active ? 0 : -1)}
            className={'ch-nav-item ch-list-item' + (active ? ' ch-list-item-active' : '') + (className ? ' ' + className : '') + (disabled ? ' ch-list-item-disabled' : '')}>
            {brandConfig.disableConcepts && user.teacher && classId !== undefined && classId > 0 &&
                <Switch className={"margin-r--m"} onChange={handleChangeEnabled} onClick={(e) => e.stopPropagation()} size="small" color="primary" name="enabled" checked={enabled}/>
            }
            <ListItemCore meta={meta}>
                <span className="ch-mathjax" dangerouslySetInnerHTML={{ __html: topic.topicName}} />
            </ListItemCore>
        </button>
    )
}

NavTopicItem.propTypes ={
    enabled: PropTypes.bool
}

export default NavTopicItem;